export default __webpack_public_path__ + "static/5-f1bf0504f9ba4bbc1ba65fe0fd342aec.png";